/**
 * Monta o endereço exibido em listagens e detalhes do imóvel.
 * Formato alinhado ao cadastro manual via CEP: "Rua, Bairro, Cidade - UF"
 */
export function buildPropertyDisplayAddress({
  street = '',
  number = '',
  complement = '',
  neighborhood = '',
  city = '',
  state = '',
} = {}) {
  const parts = [];
  const streetLine = [street, number].filter(Boolean).join(', ');
  if (streetLine) parts.push(streetLine);
  if (complement) parts.push(complement);

  const locationLine = [neighborhood, city].filter(Boolean).join(', ');
  const region = [locationLine, state].filter(Boolean).join(' - ');
  if (region) parts.push(region);

  return parts.join(', ');
}

export function getPropertyDisplayAddress(property) {
  if (!property) return '';
  const saved = String(property.address || '').trim();
  if (saved) return saved;
  return buildPropertyDisplayAddress(property);
}
